import React, { memo } from 'react';
import classNames from 'classnames';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import styles from './AttributeMappingRowWrapper.module.scss';

interface Props {
  isSubItemRemovable?: boolean;
  onRemove: () => void;
  parentValue?: unknown[];
  subFieldsMinLength?: number;
  children: React.ReactNode;
}

function AttributeMappingRowWrapper({
  isSubItemRemovable = true,
  onRemove,
  parentValue,
  subFieldsMinLength,
  children,
}: Props) {
  const isDeleteBtnVisible = subFieldsMinLength
    ? isSubItemRemovable && (parentValue?.length ?? 0) > subFieldsMinLength
    : isSubItemRemovable;

  return (
    <div className={classNames(styles.rowWrap, styles.rowWrapWithAction)}>
      {children}
      <IconButton
        icon="close"
        rounded
        type={IconButtonTypes.TertiaryFilled}
        onClick={onRemove}
        className={styles.actionBtn}
        disabled={!isDeleteBtnVisible}
      />
    </div>
  );
}

export default memo(AttributeMappingRowWrapper);
